// extracted by mini-css-extract-plugin
module.exports = {"container":"shared-components-Tabs-TabList__container--3Hfmd"};